var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var changes = require('./tripletrax.changes.js');

function registerMailsEvents() {

    $('body').on('click', '.tt-compose-mail,.tt-mail-header a,.tt-reply-mail,.tt-reply-all-mail,.tt-forward-mail', function (e) {
        e.preventDefault();

        utils.GLOBALS.mailAttachments.length = 0;

        var element = this;
        var url = $(element).attr('href');
        var previousMail = null;
        var sendDate = null;
        var subject = null;
        var to = null;
        var from = null;
        if ($(element).hasClass('tt-reply-mail') || $(element).hasClass('tt-reply-all-mail') || $(element).hasClass('tt-forward-mail')) {
            previousMail = $($('.inbox-message').children()[0]).html();
            sendDate = $('.tt-format-long-d').text();
            subject = $('.email-open-header').find('label').text();
            to = $('#to_reply').val();
            from = $('#from_reply').val();
        }
        $(element).addClass('disabled');
        ajax.ajaxCall(url, 'GET', null, false, function (data) {
            utils.setHtmlData($("#content-detail"), data, true);

            if (!utils.isUndefined($(element).data().userId)) {
                $('[name="mail_to"]').val([$(element).data().userId]).trigger('change.select2');
            }
            if ($(element).hasClass('tt-reply-mail') || $(element).hasClass('tt-reply-all-mail') || $(element).hasClass('tt-forward-mail')) {
                var header =
                    '<p class="MsoNormal"><o:p><br></o:p></p>' +
                    '<p class="MsoNormal"><o:p><br></o:p></p>' +
                    '<p class="MsoNormal">----- ' + trans('tripletrax.original_message') + ' -----<br>' +
                    '<b>' + trans('tripletrax.from') + '</b>: ' + from + ' <br>' +
                    '<b>' + trans('tripletrax.sent') + '</b>: ' + sendDate + '<br>' +
                    '<b>' + trans('tripletrax.to') + '</b>: ' + to + '<br>' +
                    '<b>' + trans('tripletrax.subject') + '</b>: ' + subject + '</p>' +
                    '<p class="MsoNormal"><o:p><br></o:p></p>';

                $('.summernote').summernote('code', header + previousMail);
                if ($(element).hasClass('tt-forward-mail')) {
                    $('[name="subject"]').val('Fw: ' + subject);
                } else {
                    $('[name="subject"]').val('Re: ' + subject);
                }
                $('.note-editable').focus();
            }
            if ($(element).hasClass('tt-forward-mail')) {
                if (!utils.isUndefined($(element).data().attachments)) {
                    var attachmentArray = $(element).data().attachments.split(',');
                    for (var i = 0; i < attachmentArray.length; i++) {
                        var filename = attachmentArray[i].split('|')[0];
                        var html = '<span><span>' + filename + '</span> <i class="fad fa-times-circle tt-remove-mail-attachment" data-file="' + filename + '" ></i>&nbsp;&nbsp; </span>';
                        $('#mail_attachment').append(html);
                    }
                    $('[name="mail_attachment_ids"]').val($(element).data().attachments);
                }
            }
            changes.calculateLeftNavHeight();
            $(element).removeClass('disabled');
        });
    });

    $('body').on('click', '.tt-mail-folder', function (e) {
        e.preventDefault();

        var folderName = $(this).data().folderName;

        utils.GLOBALS.mailsUnselected.length = 0;
        utils.GLOBALS.mailsSelected.length = 0;

        if ($('#table_mails').length) {
            var url = $('#table_mails')[0].dataset.tableUrl.substring(0, $('#table_mails')[0].dataset.tableUrl.lastIndexOf('/folder')) + "/folder/" + folderName + "/selection/none/search/none";
            $('#table_mails')[0].dataset.tableUrl = url;
            $('#table_mails').DataTable().ajax.url(url).load(null, false);
            $('#table_mails')[0].dataset.tableFolder = folderName;
            if (folderName === 'draft') {
                $('.tt-move-to-folder-dropdown').attr('disabled', 'disabled');
            } else {
                $('.tt-move-to-folder-dropdown').removeAttr('disabled');
                $.each($('.tt-move-to-folder-dropdown').parent().find('ul').find('li'), function(i, element) {
                    if ($(element).find('.tt-move-to-folder').length) {
                        if ($(element).find('.tt-move-to-folder').data().folderName === folderName) {
                            $(element).addClass('hide');
                        } else {
                            $(element).removeClass('hide');
                        }
                    }
                });
            }
            if (folderName === 'trash') {
                $('.tt-delete-mails-in-trash').removeClass('hide');
            } else {
                $('.tt-delete-mails-in-trash').addClass('hide');
            }
        } else {
            var element = this;
            var url = $(element).attr('href');
            $(element).addClass('disabled');
            ajax.ajaxCall(url, 'GET', null, false, function (data) {
                utils.setHtmlData($("#content-detail"), data, true);

                changes.calculateLeftNavHeight();
                $(element).removeClass('disabled');
            });
        }

        var elementNavigation1 = null;
        var elementNavigation2 = null;

        if ($(this).parents('.hidden-desktop').length) {
            elementNavigation1 = $(this);
            elementNavigation2 = $('#content').find('.tt-mail-folder-navigation-2').find('[data-folder-name="' + folderName + '"]');
        } else {
            elementNavigation1 = $('#content').find('.tt-mail-folder-navigation-1').find('[data-folder-name="' + folderName + '"]');
            elementNavigation2 = $(this);
        }

        if (elementNavigation1.length) {
            elementNavigation1.parents('.hidden-desktop').find('.tt-selected-mail-folder').text(elementNavigation1.text());
            elementNavigation1.parents('ul').find('i').remove();
            elementNavigation1.append(' <i class="fad fa-check"></i>');
        }

        elementNavigation2.parents('ul').find('.active').removeClass('active');
        elementNavigation2.parent().addClass('active');
        if (elementNavigation2.text().lastIndexOf(' (') >= 0) {
            $('.page-title').text(elementNavigation2.text().substr(0, elementNavigation2.text().lastIndexOf(' (')));
        } else {
            $('.page-title').text(elementNavigation2.text());
        }
        if (folderName === 'inbox') {
            $('.page-title').prepend('<i class="fad fa-fw fa-inbox"></i>');
        } else if (folderName === 'trash') {
            $('.page-title').prepend('<i class="fad fa-fw fa-trash-alt"></i>');
        } else if (folderName === 'sent') {
            $('.page-title').prepend('<i class="fad fa-fw fa-paper-plane"></i>');
        } else if (folderName === 'draft') {
            $('.page-title').prepend('<i class="fad fa-fw fa-file"></i>');
        } else {
            $('.page-title').prepend('<i class="fad fa-fw fa-folder"></i>');
        }
    });

    $('body').on('click', '.tt-mail-selection', function (e) {
        e.preventDefault();

        var type = $(this).data().selectionType;

        utils.GLOBALS.mailsUnselected.length = 0;
        utils.GLOBALS.mailsSelected.length = 0;

        var searchValue = 'none';
        if ($('.tt-datatable-search').val() !== '') {
            searchValue = $('.tt-datatable-search').val();
        }

        var url = $('#table_mails')[0].dataset.tableUrl.substring(0, $('#table_mails')[0].dataset.tableUrl.lastIndexOf('/selection')) + "/selection/" + type + "/search/" + searchValue;
        $('#table_mails')[0].dataset.tableUrl = url;
        $('#table_mails').DataTable().ajax.url(url).load(null, false);
    });

    $('body').on('click', '.tt-cancel-mail', function (e) {
        e.preventDefault();

        $('.inbox-menu-lg').find('[data-folder-name="' + $('.inbox-menu-lg').find('li.active').find('a').data().folderName + '"]').click();
    });

    $('body').on('click', '.tt-delete-mail,.tt-delete-mail-compose', function (e) {
        e.preventDefault();

        var element = $(this);
        var id = $('[name="mail_id"]').val();
        var folder = $('.inbox-menu-lg').find('li.active').find('a').data().folderName;
        var folderToDelete = '';
        if (element.hasClass('tt-delete-mail-compose')) {
            folderToDelete = 'draft';
        } else {
            folderToDelete = $('.inbox-menu-lg').find('li.active').find('a').data().folderName;
        }

        if (folder === "trash") {
            // Nachfrage nur bei endg�ltigem L�schen
            $.SmartMessageBox({
                title: "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_mail'),
                content: Lang.get('tripletrax.delete_mail_desc'),
                buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
            }, function (ButtonPressed) {
                if (ButtonPressed === Lang.get('tripletrax.yes')) {
                    ajax.ajaxCall(element[0].getAttribute("action") + "/" + id, element[0].getAttribute("method"), '_method=DELETE&mail_folder=' + folderToDelete, false, function (data) {

                        $('.inbox-menu-lg').find('[data-folder-name="' + folder + '"]').click();
                    });
                }
            });
        }
        else {
            ajax.ajaxCall(element[0].getAttribute("action") + "/" + id, element[0].getAttribute("method"), '_method=DELETE&mail_folder=' + folderToDelete, false, function (data) {

                $('.inbox-menu-lg').find('[data-folder-name="' + folder + '"]').click();
            });
        }

        if (folderToDelete === "draft") {
            if ($('[name="mail_id"]').val() !== "") {
                if ($('[data-folder-name="draft"]').length) {
                    var unreadMails = parseInt($('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').text().replace('(', '').replace(')', ''));
                    if (unreadMails <= 1) {
                        $('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').remove();
                    } else {
                        $('.inbox-menu-lg').find('[data-folder-name="draft"]').find('strong').text('(' + (unreadMails - 1) + ')');
                    }
                }
            }
        }
    });

    $('body').on('click', '.tt-delete-mail-all', function (e) {
        e.preventDefault();

        var element = $(this);
        var folder = $('.inbox-menu-lg').find('li.active').find('a').data().folderName;
        var data = getMailSelection();

        if (folder === "trash") {
            // Nachfrage nur bei endg�ltigem L�schen
            $.SmartMessageBox({
                title: "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_mails'),
                content: Lang.get('tripletrax.delete_mails_desc'),
                buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
            }, function (ButtonPressed) {
                if (ButtonPressed === Lang.get('tripletrax.yes')) {
                    ajax.ajaxCall(element[0].getAttribute("action"), element[0].getAttribute("method"), data, false, function (data) {

                        utils.GLOBALS.mailsUnselected.length = 0;
                        utils.GLOBALS.mailsSelected.length = 0;

                        if (data.length === 2) {
                            utils.setHtmlData($("#content"), data[0], true);

                            if (folder === "trash") {
                                var unreadMails = parseInt($('#mail_nav').find('.badge').text());
                                if (unreadMails == data[1]) {
                                    $('#mail_nav').find('.badge').remove();
                                } else {
                                    $('#mail_nav').find('.badge').text((unreadMails - data[1]).toString());
                                }
                            }
                        }
                    });
                }
            });
        } else {
            ajax.ajaxCall(element[0].getAttribute("action"), element[0].getAttribute("method"), data, false, function (data) {

                utils.GLOBALS.mailsUnselected.length = 0;
                utils.GLOBALS.mailsSelected.length = 0;

                if (data.length === 2) {
                    utils.setHtmlData($("#content"), data[0], true);

                    if (folder === "trash") {
                        var unreadMails = parseInt($('#mail_nav').find('.badge').text());
                        if (unreadMails == data[1]) {
                            $('#mail_nav').find('.badge').remove();
                        } else {
                            $('#mail_nav').find('.badge').text((unreadMails - data[1]).toString());
                        }
                    }
                }
            });
        }
    });

    $('body').on('click', '.tt-move-to-folder', function (e) {
        e.preventDefault();

        moveSelectedMailsToFolder($(this).attr('href'), $(this).data().folderName);
    });

    $('body').on('click', '.tt-add-mail-attachment', function (e) {
        e.preventDefault();

        $('#hidden_mail_attachment')[0].click();
    });

    $('body').on('change', '#hidden_mail_attachment', function (e) {

        var files = e.target.files;
        var filesArr = Array.prototype.slice.call(files);
        filesArr.forEach(function(file) {

            var fileExisting = false;
            for (var i = 0; i < utils.GLOBALS.mailAttachments.length ; i++) {
                if(utils.GLOBALS.mailAttachments[i].name === file.name) {
                    fileExisting = true;
                    break;
                }
            }
            if (!fileExisting) {
                var alreadySavedFiles = $('[name="mail_attachment_ids"]').val();
                if (alreadySavedFiles !== '') {
                    $.each(alreadySavedFiles.split(','), function (i, val) {
                        if (val.split('|')[0] === file.name) {
                            fileExisting = true;
                            return false;
                        }
                    });
                }
            }

            if (!fileExisting) {
                utils.GLOBALS.mailAttachments.push(file);

                var reader = new FileReader();
                reader.onload = function (e) {
                    var html = '<span><span>' + file.name + '</span> <i class="fad fa-times-circle tt-remove-mail-attachment" data-file="' + file.name + '" ></i>&nbsp;&nbsp; </span>';
                    $('#mail_attachment').append(html);
                };
                reader.readAsDataURL(file);
            }
        });
    });

    $('body').on('click', '.tt-remove-mail-attachment', function (e) {
        e.preventDefault();

        var file = $(this).data('file');
        // in den neu hinzugefügten Anhängen suchen
        for (var i = 0; i < utils.GLOBALS.mailAttachments.length ; i++) {
            if(utils.GLOBALS.mailAttachments[i].name === file) {
                utils.GLOBALS.mailAttachments.splice(i,1);
                break;
            }
        }
        // in den bereits gespeicherten Anh�ngen suchen
        var alreadySavedFiles = $('[name="mail_attachment_ids"]').val();
        if (alreadySavedFiles !== '') {
            var splittedFiles = alreadySavedFiles.split(',');
            for (var i = 0; i < splittedFiles.length; i++) {
                if (splittedFiles[i].split('|')[0] === file) {
                    splittedFiles.splice(i, 1);
                    break;
                }
            }
            $('[name="mail_attachment_ids"]').val(splittedFiles.join());
        }
        $(this).parent().remove();
    });

    $('body').on('click', '.tt-print-mail', function (e) {
        e.preventDefault();

        printMail($(this).attr('href'));
    });

    $('body').on('click', '.tt-print-mail-compose', function (e) {
        e.preventDefault();

        $('[name="do_print"]').val('true');
        $('.tt-save-mail-as-draft').click();
    });

    $('body').on('click', '.tt-download-all-mail-attachments', function (e) {
        e.preventDefault();

        $.each($(this).parents('.inbox-download').find('.tt-download-single-mail-attachment'), function (i, element) {
            $(element).click();
        });
    });

    $('body').on('click', '.tt-download-single-mail-attachment', function (e) {
        e.preventDefault();

        window.open('doc/mail/attachment/download/' + $(this).data().downloadUrl.split('/')[1] + '/' + $(this).data().fileName, '_blank');
    });
}

function getMailSelection() {

    var folder = $('.inbox-menu-lg').find('li.active').find('a').data().folderName;
    var search = $('#table_mails')[0].dataset.tableUrl.substring($('#table_mails')[0].dataset.tableUrl.lastIndexOf('/') + 1);
    var selection = $('#table_mails')[0].dataset.tableUrl.substring($('#table_mails')[0].dataset.tableUrl.lastIndexOf('/selection') + 11, $('#table_mails')[0].dataset.tableUrl.lastIndexOf('/search'));
    var selectedArray = utils.GLOBALS.mailsSelected.join();
    var unselectedArray = utils.GLOBALS.mailsUnselected.join();

    return 'mail_folder=' + folder + '&search=' + search + '&selection=' + selection + '&selected_items=' + selectedArray + '&unselected_items=' + unselectedArray;
}

function moveSelectedMailsToFolder(url, folderName) {

    var data = getMailSelection();

    ajax.ajaxCall(url + '/folder/' + folderName, 'POST', data, false, function (data) {

        utils.GLOBALS.mailsUnselected.length = 0;
        utils.GLOBALS.mailsSelected.length = 0;

        utils.setHtmlData($("#content"), data, true);
    });
}

function printMail(url) {

    var printWindow = window.open(url);

    printWindow.onload = function () {
        printWindow.document.title = trans('tripletrax.message');
        printWindow.document.close();
        printWindow.print();
        setTimeout(function () {
            printWindow.close();
        }, 1);
    }
}

module.exports.registerMailsEvents = registerMailsEvents;
module.exports.moveSelectedMailsToFolder = moveSelectedMailsToFolder;
module.exports.printMail = printMail;
